import React from "react";

function InterestReportTable(props) {
  const { data, seg, totalMTF } = props;

  return (
    <>
      <div className="table-responsive scroll-table report-table-wrapper ">
        <table className="table last-column">
          <thead>
            {seg === "mtf" && (
              <tr>
                <th scope="col" className="">
                  TXN DATE
                </th>
                <th scope="col" className="text-center">
                  NET LEDGER BAL
                </th>
                <th scope="col" className="text-center">
                  MTF INT AMOUNT
                </th>
                <th scope="col" className="text-center">
                  INTEREST RATE
                </th>
              </tr>
            )}
            {seg === "dpc" && (
              <tr>
                <th scope="col" className="">
                  DATE
                </th>
                <th scope="col" className="text-center">
                  INTEREST CHARGES
                </th>
                <th scope="col" className="text-center">
                  LEDGER BALANCE
                </th>
                <th scope="col" className="text-center">
                  INTEREST RATE
                </th>
              </tr>
            )}
            {seg === "prop" && (
              <tr>
                <th scope="col" className="">
                  REPORT DATE
                </th>
                <th scope="col" className="text-center">
                   PROP ALLOCATION
                </th>
                <th scope="col" className="text-center">
                  DPC INT
                </th>
                <th scope="col" className="text-center">
                  DPC AMOUNT
                </th>
              </tr>
            )}
          </thead>
          <tbody>
            {data &&
              data.map((item, key) => {
                return (
                  <>
                    {seg === "mtf" && (
                      <tr key={key}>
                        <td>{item?.txnDate || "-"}</td>
                        <td>{item?.netLedgerBal || 0}</td>
                        <td>{item?.mtfIntAmount || 0}</td>
                        <td>{item?.intRate || 0}</td>
                      </tr>
                    )}
                    {seg === "dpc" && (
                      <tr key={key}>
                        <td>{item?.date || "-"}</td>
                        <td>{item?.intrestCharges || 0}</td>
                        <td>{item?.ledgerBalance || 0}</td>
                        <td>{item?.intrestRate || 0}</td>
                      </tr>
                    )}
                     {seg === "prop" && (
                      <tr key={key}>
                        <td>{item?.reportDate || "-"}</td>
                        <td>{item?.allocationFromProp || 0}</td>
                        <td>{item?.dpcInt || 0}</td>
                        <td>{item?.dpcAmt || 0}</td>
                      </tr>
                    )}
                  </>
                );
              })}
          </tbody>
          <tbody className="interest-table-body-total">
            <tr>
              <td>Total</td>
              {
                seg === "prop" ?
                <>
                  <td>{seg === "prop" && totalMTF}</td>
                  <td></td>
                  <td></td>
                </>
                : 
                <>
                  <td>{seg === "dpc" && totalMTF}</td>
                  <td>{seg === "mtf" && totalMTF}</td>                  
                  <td>{seg === "prop" && totalMTF}</td>
                </>
              }
              {/* <td>{seg === "dpc" && totalMTF}</td>
              <td>{seg === "mtf" && totalMTF}</td>
              
              <td></td> */}
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
}
export default InterestReportTable;
